import { motion } from 'framer-motion'
import styles from './HeroSection.module.css'
import { MagneticButton } from './MagneticButton'

const container = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.12, delayChildren: 0.3 } },
}

const item = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.25, 0.1, 0.25, 1] as const } },
}

export function HeroSection() {
    return (
        <section className={styles.hero}>
            {/* Background image */}
            <div className={styles.heroBg}>
                <img
                    src="/brandbook/9_portada.svg"
                    alt=""
                    className={styles.heroImg}
                    aria-hidden="true"
                />
            </div>
            <div className={styles.heroOverlay} />

            {/* Content */}
            <div className={styles.heroContent}>
                <motion.div
                    className={styles.heroLeft}
                    variants={container}
                    initial="hidden"
                    animate="visible"
                >
                    <motion.p className={styles.heroEyebrow} variants={item}>
                        Veracruz, México — Plástico reciclado del mar
                    </motion.p>

                    <motion.h1 className={styles.heroTitle} variants={item}>
                        Diseñados por nosotros,{' '}
                        <em>armados por ti.</em>
                    </motion.h1>

                    <motion.p className={styles.heroDescription} variants={item}>
                        Tomamos plástico que el mundo descartó desde las costas de Veracruz y lo convertimos en carátulas para lentes
                        donde tú tienes la última palabra. Cambia la carátula de tus lentes y cambia tu estilo.
                    </motion.p>

                    <motion.div className={styles.heroActions} variants={item}>
                        <MagneticButton
                            onClick={() => window.location.hash = 'products'}
                            size="lg"
                        >
                            Ver Colección
                        </MagneticButton>
                        <MagneticButton
                            onClick={() => window.location.hash = 'customize'}
                            variant="outline"
                            size="lg"
                        >
                            Configura los tuyos
                        </MagneticButton>
                    </motion.div>
                </motion.div>

                <div className={styles.heroRight}>
                    <div className={styles.scrollIndicator}>
                        <div className={styles.scrollLine} />
                        <span>Scroll</span>
                    </div>
                </div>
            </div>

            {/* Cover color accent stripe at bottom */}
            <div className={styles.heroStripe} aria-hidden="true">
                <span style={{ background: 'var(--color-cover-red)' }} />
                <span style={{ background: 'var(--color-cover-yellow)' }} />
                <span style={{ background: 'var(--color-cover-green)' }} />
                <span style={{ background: 'var(--color-cover-blue)' }} />
            </div>
        </section>
    )
}
